import styled from 'styled-components';

// CONTAINER PRINCIPAL
export const Container = styled.section`
  width: 100%;
  padding: 1rem 0;
  background-color: white;
`;

export const ContentWrapper = styled.div`
  display: flex;
  max-width: 900px;
  margin: 0 auto;
  gap: 2rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 0 2rem;
    gap: 3rem;
    margin-top: -5rem
  }
`;

// COLUNA DE TEXTO (ESQUERDA)
export const TextColumn = styled.div`
  flex: 1;
  padding-right: 1rem;
`;

export const QuestionTitle = styled.h2`
  font-size: 2.2rem;
  color: #272643;
  margin-bottom: 1.5rem;
  text-align: left;
`;

export const AnswerText = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 2rem;
  text-align: left;
`;

export const DownloadButton = styled.button`
  background-color: #2563EB;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1c51c7;
  }
`;

// COLUNA DO CHAT (DIREITA)
export const ChatColumn = styled.div`
  flex: 1;
  padding-left: 1rem;
`;

export const ChatInterface = styled.div`
  width: 100%;
  max-width: 450px;
  background-color: #f5f5f5;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

// HEADER DO CHAT
export const ChatHeader = styled.div`
  background-color: #075E54;
  color: white;
  padding: 0.8rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AppName = styled.h3`
  margin: 0;
  font-size: 1.1rem;
`;

export const TimeDisplay = styled.span`
  font-size: 0.9rem;
`;

// CORPO DO CHAT
export const ChatBody = styled.div`
  padding: 1.5rem;
  background-color: #ECE5DD;
`;

export const ContextLabel = styled.h4`
  font-size: 1rem;
  color: #272643;
  margin: 0 0 0.5rem 0;
    text-align: left;
`;

export const ContextDescription = styled.p`
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 1.5rem;
    text-align: left;
`;

// BOLHA DE MENSAGEM
export const MessageBubble = styled.div`
  background-color: #DCF8C6;
  border-radius: 8px;
  padding: 0.8rem 1rem;
  margin-bottom: 1rem;
  max-width: 90%;
  align-self: flex-end;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
`;

export const MessageText = styled.p`
  font-size: 0.95rem;
  color: #303030;
  margin: 0;
  line-height: 1.4;
  text-align: left;
`;

export const TimeEstimate = styled.p`
  font-size: 0.85rem;
  color: #888;
  text-align: right;
  margin-bottom: 1.5rem;
`;

// SEÇÃO INFERIOR DO CHAT
export const KeyCorrelations = styled.h4`
  font-size: 1rem;
  color: #272643;
  margin: 0 0 0.5rem 0;
`;

export const CorrelationText = styled.p`
  font-size: 0.9rem;
  color: #555;
  font-style: italic;
`;

